import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import classNames from "classnames";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import HeaderStatus from "./HeaderStatus";
import ChartJobStatus from "./ChartJobStatus";
import ChartTimeRemain from "./ChartTimeRemain";
import LoadingPage from "components/Loading/LoadingPage";
import BarJobType from "./BarJobType";

// HOOKS
// import useGetAllLoanRequest from "../../hooks/useGetAllLoanRequest";
import useGetDashboard from "../../hooks/useGetDashboard";
// import useOverviewStatus from "../../hooks/useOverviewStatus";
// import useGetTimeRemain from "../../hooks/useGetTimeRemain";
// import useGetOverviewPurpose from "../../hooks/useGetOverviewPurpose";

// UTILS
import { getCurrentLocalDateTime, months } from "../../utils/getLocalDateTime";

function DashboardMain() {
  const today = getCurrentLocalDateTime();

  const min = `${today.year}-${today.month}-01`;
  const max = `${today.year}-${today.month}-${months[today.monthIndex].days}`;

  const DEFAULT_QUERY = {
    Limit: -1,
    min: today.fullDate,
    max: today.fullDate,
    status: "All",
    package: "All",
  };

  const [activeDuringTime, setActiveDuringTime] = useState("1day");
  const [triggerTime, setTriggerTime] = useState(false);
  const [query, setQuery] = useState(DEFAULT_QUERY);

  const { datas, loading, error, getData, refetch } = useGetDashboard(query);

  // const {
  //   datas: datasOverviewStatus,
  //   loading: loadingOverviewStatus,
  //   error: errorOverviewStatus,
  //   getData: getDataOverviewStatus,
  // } = useOverviewStatus();

  // const {
  //   datas: datasTimeRemain,
  //   loading: loadingTimeRemain,
  //   error: errorTimeRemain,
  //   getData: getDataTimeRemain,
  // } = useGetTimeRemain();

  // const {
  //   datas: datasOverviewPurpose,
  //   loading: loadingOverviewPurpose,
  //   error: errorOverviewPurpose,
  //   getData: getDataOverviewPurpose,
  // } = useGetOverviewPurpose();

  const onDuringTime = (duringTimeKey) => async () => {
    const NEW_QUERY = query;

    if (duringTimeKey === "1month") {
      NEW_QUERY.min = min;
      NEW_QUERY.max = max;
    } else if (duringTimeKey === "1day") {
      const nowToday = today.fullDate;
      NEW_QUERY.min = nowToday;
      NEW_QUERY.max = nowToday;
    }
    setQuery(NEW_QUERY);
    setActiveDuringTime(duringTimeKey);
    await refetch(NEW_QUERY);
  };

  useEffect(() => {
    setTimeout(async () => {
      await refetch(query);
      // await getDataOverviewStatus();
      // await getDataOverviewPurpose();
      // await getDataTimeRemain();
      setTriggerTime(!triggerTime);
    }, 300000);
  }, [triggerTime]);

  let count = {
    WAIT: 0,
    WAIT_REFERAL: 0,
    APPROVE: 0,
    RETURN: 0,
    COMPLETE: 0,
    CANCEL: 0,
    CONFIRMED: 0,
    DONE: 0,
    FINISHED: 0,
    TRANSFER_FAIL: 0,
    UNKNOWN: 0,
    ALL: 0,
  };

  let countPurpose = {
    CONSUME: {
      name: "อุปโภค / บริโภค",
      total: 0,
    },
    TRAVEL: {
      name: "ท่องเที่ยว",
      total: 0,
    },
    BUSINESS: {
      name: "ธุรกิจ",
      total: 0,
    },
    UNKNOWN: {
      total: 0,
    },
  };

  let countTimeRemain = {
    "15min": 0,
    "30min": 0,
    "60min": 0,
    "60minMore": 0,
  };

  let countTimeRemain2 = {
    "15min": 0,
    "30min": 0,
    "60min": 0,
    "60minMore": 0,
  };

  if (loading)
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  if (error) return <p>Error</p>;

  // datas.forEach((data) => {
  //   const status = data?.loan_status;
  //   const purpose = data?.purpose;
  //   const time_remain = data?.time_remain / 60000;
  //   const time_remain2 = (new Date().getTime() - data?.timestamp) / 60000;

  //   switch (status) {
  //     case "อนุมัติ":
  //       count.ALL++;
  //       count.COMPLETE++;
  //       break;
  //     case "ไม่ผ่าน":
  //       count.ALL++;
  //       count.CANCEL++;
  //       break;
  //     case "รับคำร้อง":
  //       count.ALL++;
  //       count.WAIT++;
  //       break;
  //     case "รอติดต่อบุคคลอ้างอิง":
  //       count.ALL++;
  //       count.WAIT_REFERAL++;
  //       break;
  //     case "รอผู้ยื่นคำร้องแก้ไข":
  //       count.ALL++;
  //       count.RETURN++;
  //       break;
  //     case "รออนุมัติ":
  //       count.ALL++;
  //       count.APPROVE++;
  //       break;
  //     case "ยืนยัน":
  //       count.ALL++;
  //       count.CONFIRMED++;
  //       break;
  //     case "สมบูรณ์":
  //       count.ALL++;
  //       count.DONE++;
  //       break;
  //     case "สิ้นสุด":
  //       count.ALL++;
  //       count.FINISHED++;
  //       break;
  //     case "โอนเงินไม่สำเร็จ":
  //       count.ALL++;
  //       count.TRANSFER_FAIL++;
  //       break;
  //     default:
  //       count.UNKNOWN++;
  //       console.log("UNKNOWN STATUS");
  //       break;
  //   }

  //   switch (purpose) {
  //     case "อุปโภค / บริโภค":
  //       countPurpose.CONSUME.total++;
  //       break;
  //     case "ท่องเที่ยว":
  //       countPurpose.TRAVEL.total++;
  //       break;
  //     case "ธุรกิจ":
  //       countPurpose.BUSINESS.total++;
  //       break;
  //     default:
  //       countPurpose.UNKNOWN.total++;
  //       console.log("UNKNOWN PURPOSE");
  //       break;
  //   }

  //   if (
  //     ![
  //       "ไม่ผ่าน",
  //       "รอผู้ยื่นคำร้องแก้ไข",
  //       "สมบูรณ์",
  //       "สิ้นสุด",
  //       "ยืนยัน",
  //       "อนุมัติ",
  //     ].includes(status)
  //   ) {
  //     if (time_remain <= 15) {
  //       countTimeRemain["15min"]++;
  //     } else if (time_remain <= 30) {
  //       countTimeRemain["30min"]++;
  //     } else if (time_remain < 60) {
  //       countTimeRemain["60min"]++;
  //     } else {
  //       countTimeRemain["60minMore"]++;
  //     }

  //     if (time_remain2 <= 15) {
  //       countTimeRemain2["15min"]++;
  //     } else if (time_remain2 <= 30) {
  //       countTimeRemain2["30min"]++;
  //     } else if (time_remain2 < 60) {
  //       countTimeRemain2["60min"]++;
  //     } else {
  //       countTimeRemain2["60minMore"]++;
  //     }
  //   }
  // });

  const duringTimes = [
    {
      key: "1month",
      name: "1 Month",
    },
    {
      key: "1day",
      name: "1 Day",
    },
  ];

  return (
    <ContainerContent>
      <div className="flex mx-10 mb-4 items-center">
        <div>ดึงข้อมูลตามระยะเวลา</div>
        <div className="flex mx-4 space-x-2">
          {duringTimes.map((duringTime) => (
            <button
              onClick={onDuringTime(duringTime.key)}
              key={duringTime.key}
              className={classNames(
                "border rounded border-gray-200 shadow-sm px-2 py-1 text-white transition-all duration-300 focus:outline-none",
                {
                  "bg-blue-600 ": activeDuringTime === duringTime.key,
                  "bg-gray-400 hover:bg-blue-400":
                    activeDuringTime !== duringTime.key,
                }
              )}
            >
              {duringTime.name}
            </button>
          ))}
        </div>
      </div>
      <HeaderStatus count={datas.count} />
      <div className="grid grid-cols-1 md:grid-cols-2">
        <ChartJobStatus count={datas.count} />
        <BarJobType countPurpose={datas.countPurpose} />
        <ChartTimeRemain
          title="Time Remain"
          countTimeRemain={datas.countTimeRemain}
        />
        <ChartTimeRemain
          title="Request Waiting Time"
          countTimeRemain={datas.countTimeRemain2}
        />
      </div>
      {/* <div className="px-20">
        <BarJobType />
      </div> */}
      <div className="w-full text-center">
        <span className="mr-4"> จะถูกอัพเดทในอีก </span>
        <Countdown date={Date.now() + 1000 * 300} />
      </div>
    </ContainerContent>
  );
}

export default DashboardMain;
